import type { UserDto } from "@/lib/api/types/enterprise";

import { MOCK_TENANT_ID, MOCK_USER_ID } from "../constants";

const DEMO_DISTRIBUTOR_ID = "33333333-3333-3333-3333-333333333333";
const DEMO_END_USER_ID = "44444444-4444-4444-4444-444444444444";
const SUPER_ADMIN_ID = "55555555-5555-5555-5555-555555555555";
const DEMO_TENANTS = [
  {
    id: MOCK_TENANT_ID,
    name: "Demo Workspace",
    domain: null,
    is_active: true,
  },
];

const t0 = "2024-01-01T00:00:00.000Z";

export const MOCK_USERS: UserDto[] = [
  {
    id: SUPER_ADMIN_ID,
    email: "superadmin@local.dev",
    name: "Local Super Admin",
    role: "super_admin",
    account_status: "active",
    is_active: true,
    tenant_id: MOCK_TENANT_ID,
    tenant_ids: [MOCK_TENANT_ID],
    tenants: DEMO_TENANTS,
    organization_id: null,
    organization_name: null,
    admin_user_id: null,
    admin_email: null,
    distributor_user_id: null,
    distributor_email: null,
    invitation_sent_at: null,
    invitation_expires_at: null,
    password_set_at: t0,
    created_at: t0,
  },
  {
    id: MOCK_USER_ID,
    email: "admin@local.dev",
    name: "Local Admin",
    role: "admin",
    account_status: "active",
    is_active: true,
    tenant_id: MOCK_TENANT_ID,
    tenant_ids: [MOCK_TENANT_ID],
    tenants: DEMO_TENANTS,
    organization_id: null,
    organization_name: null,
    admin_user_id: null,
    admin_email: null,
    distributor_user_id: null,
    distributor_email: null,
    invitation_sent_at: null,
    invitation_expires_at: null,
    password_set_at: t0,
    created_at: t0,
  },
  {
    id: DEMO_DISTRIBUTOR_ID,
    email: "distributor@local.dev",
    name: "Demo Distributor",
    role: "distributor",
    account_status: "active",
    is_active: true,
    tenant_id: MOCK_TENANT_ID,
    tenant_ids: [MOCK_TENANT_ID],
    tenants: DEMO_TENANTS,
    organization_id: null,
    organization_name: null,
    admin_user_id: null,
    admin_email: null,
    distributor_user_id: null,
    distributor_email: null,
    invitation_sent_at: null,
    invitation_expires_at: null,
    password_set_at: t0,
    created_at: t0,
  },
  {
    id: DEMO_END_USER_ID,
    email: "user@local.dev",
    name: "Demo End User",
    role: "user",
    account_status: "active",
    is_active: true,
    tenant_id: MOCK_TENANT_ID,
    tenant_ids: [MOCK_TENANT_ID],
    tenants: DEMO_TENANTS,
    organization_id: null,
    organization_name: null,
    admin_user_id: MOCK_USER_ID,
    admin_email: "admin@local.dev",
    distributor_user_id: DEMO_DISTRIBUTOR_ID,
    distributor_email: "distributor@local.dev",
    invitation_sent_at: null,
    invitation_expires_at: null,
    password_set_at: t0,
    created_at: t0,
  },
  {
    id: "44444444-4444-4444-4444-444444444401",
    email: "field.ops@partner.in",
    name: "Field Ops (invited)",
    role: "user",
    account_status: "invited",
    is_active: true,
    tenant_id: MOCK_TENANT_ID,
    tenant_ids: [MOCK_TENANT_ID],
    tenants: DEMO_TENANTS,
    organization_id: null,
    organization_name: null,
    admin_user_id: MOCK_USER_ID,
    admin_email: "admin@local.dev",
    distributor_user_id: null,
    distributor_email: null,
    invitation_sent_at: t0,
    invitation_expires_at: "2024-01-08T00:00:00.000Z",
    password_set_at: null,
    created_at: t0,
  },
];
